module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07482_banner_800x600.d2f1f80d.png";